import React, { useMemo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import withStyles from 'utils/withStyles';

import { SignUp } from 'components/auth-ru/SignUp/SignUp';
import ResetPassword from 'components/auth/ResetPassword/ResetPassword';
import ChangePassword from 'components/auth/ChangePassword/ChangePassword';
import Figures from 'components/common/Home/Figures';
import Footer from 'components/common/Footer/Footer';

import { useUser } from 'hooks';
import IsomorphicRedirect from 'components/common/IsomorphicRedirect/IsomorphicRedirect';
import s from './Auth.css';

const Login = () => <SignUp isLogin />;

const Auth = () => {
  const user = useUser();
  const memoed = useMemo(() => user, []);

  // Redirects are managed by redirects itself. Auth component should not interfere
  if (memoed) {
    return (
      <IsomorphicRedirect to="/tasks" />
    );
  }

  return (
    <div className={s.auth}>
      <Figures />
      <div className={s.content}>
        <Switch>
          <Route path="/auth/signup" exact component={SignUp} />
          <Route path="/auth/signin" exact component={Login} />
          <Route path="/auth/reset" exact component={ResetPassword} />
          <Route
            path="/restorePassword/:userId/:restoreToken"
            exact
            component={ChangePassword}
          />
          <Route path="*" component={() => <Redirect to="/" />} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default withStyles(s)(Auth);
